/* tslint:disable */
import {
  Partner,
  PartnerContact
} from '../index';

declare var Object: any;
export interface PartnerAddressInterface {
  "id"?: number;
  "name"?: string;
  "contact_id"?: number;
  "partner_id"?: number;
  "street"?: string;
  "street2"?: string;
  "zip"?: string;
  "city"?: string;
  "child_ids"?: Array<any>;
  partner?: Partner;
  childs?: PartnerAddress[];
  contact?: PartnerContact;
}

export class PartnerAddress implements PartnerAddressInterface {
  "id": number;
  "name": string;
  "contact_id": number;
  "partner_id": number;
  "street": string;
  "street2": string;
  "zip": string;
  "city": string;
  "child_ids": Array<any>;
  partner: Partner;
  childs: PartnerAddress[];
  contact: PartnerContact;
  constructor(data?: PartnerAddressInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PartnerAddress`.
   */
  public static getModelName() {
    return "PartnerAddress";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PartnerAddress for dynamic purposes.
  **/
  public static factory(data: PartnerAddressInterface): PartnerAddress{
    return new PartnerAddress(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PartnerAddress',
      plural: 'PartnerAddresses',
      path: 'PartnerAddresses',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "contact_id": {
          name: 'contact_id',
          type: 'number'
        },
        "partner_id": {
          name: 'partner_id',
          type: 'number'
        },
        "street": {
          name: 'street',
          type: 'string'
        },
        "street2": {
          name: 'street2',
          type: 'string'
        },
        "zip": {
          name: 'zip',
          type: 'string'
        },
        "city": {
          name: 'city',
          type: 'string'
        },
        "child_ids": {
          name: 'child_ids',
          type: 'Array&lt;any&gt;',
          default: <any>[]
        },
      },
      relations: {
        partner: {
          name: 'partner',
          type: 'Partner',
          model: 'Partner',
          relationType: 'belongsTo',
                  keyFrom: 'partner_id',
          keyTo: 'id'
        },
        childs: {
          name: 'childs',
          type: 'PartnerAddress[]',
          model: 'PartnerAddress',
          relationType: 'referencesMany',
                  keyFrom: 'child_ids',
          keyTo: 'id'
        },
        contact: {
          name: 'contact',
          type: 'PartnerContact',
          model: 'PartnerContact',
          relationType: 'belongsTo',
                  keyFrom: 'contact_id',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/PartnerAddress.ts